import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const getAllUsersData = async (token, limit, offset) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const response = await axios.get(`${BACKEND_URL}api/demo_user`, config);
  return response;
};
const getAllUsers = async (token, limit, offset) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const response = await axios.get(
    `${BACKEND_URL}api/demo_user?limit=${limit}&offset=${offset}`,
    config
  );
  return response;
};

const getOneUser = async (token, id) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const response = await axios.get(`${BACKEND_URL}api/demo_user/${id}`, config);
  return response;
};

const searchUser = async (token, username) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const res = await axios.get(
    `${BACKEND_URL}api/demo_user/${username}`,
    config
  );
  return res;
};

const deleteUser = async (token, id) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const res = await axios.delete(`${BACKEND_URL}api/demo_user/${id}`, config);
  return res;
};

export default {
  getAllUsers,
  getOneUser,
  searchUser,
  deleteUser,
  getAllUsersData,
};
